import Factory from './Message/Incoming/Factory.js'
import PlayerJoin from './Message/Outgoing/PlayerJoin.js'
import EntityCollection from './Entity/EntityCollection.js'

class Game {
    
    constructor(ctx, wsUrl) {
        this.debug = {
            lastRender: null,
            fps: 0,
            test: false,
        };
        this.incomingMessageFactory = new Factory();
        this.ctx = ctx;
        this.wsUrl = wsUrl;
        this.connection = null;
        this.players = null;
        this.walls = null;
        this.bullets = null;
    }
    
    getCanvasContext() {
        return this.ctx;
    }
    
    getCanvas() {
        return this.getCanvasContext().canvas;
    }
    
    getWalls() {
        if(!this.walls) {
            this.walls = new EntityCollection();
        }
        return this.walls;
    }
    
    getPlayers() {
        if(!this.players) {
            this.players = new EntityCollection();
        }
        return this.players;
    }
    
    getBullets() {
        if(!this.bullets) {
            this.bullets = new EntityCollection();
        }
        return this.bullets;
    }
    
    init() {
        const conn = new WebSocket(this.wsUrl);
        conn.onmessage = (e) => {
            const json = JSON.parse(e.data);
            const message = this.incomingMessageFactory.create(json.type, json.data);
            message.handle(this);
        };
        conn.onopen = (e) => {
            this.sendMessage(new PlayerJoin());
        };

        this.connection = conn;
    }
    
    draw(timestamp) {
        this.ctx.clearRect(0, 0, 800, 800);
        
        const walls = this.getWalls();
        const players = this.getPlayers();
        const bullets = this.getBullets();
        
        walls.tickAll();
        players.tickAll();
        bullets.tickAll();
        
        
        walls.drawAll(this.ctx);
        players.drawAll(this.ctx);
        bullets.drawAll(this.ctx);

        if (this.debug.test) {
            console.log('RENDER', Date.now());
            this.debug.test = false;
        } else {
            //console.log('RENDER');
        }


        if (!this.debug.lastRender) {
            this.debug.lastRender = timestamp;
            this.debug.fps = 0;
        } else {
            const delta = (timestamp - this.debug.lastRender) / 1000;
            this.debug.lastRender = timestamp;
            this.debug.fps = 1 / delta;
        }
        document.getElementById('fps').textContent = 'FPS: ' + this.debug.fps;
    }

    sendMessage(message) {
        this.connection.send(JSON.stringify({
            type: message.getType(),
            data: message.getData()
        }));
    };
}

export default Game